export default "__VITE_ASSET__Bc4Gthm1__"